import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";
import { AuthService } from "../../services/auth.service";
import { Company, UserInfo } from "../../types/user.type";
import { StorageService } from "../../services/storage.service";
import { Subscription } from "rxjs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-navbar",
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit, OnDestroy {
  userName = "";
  src = "/logo-zeeway.svg";
  originalSrc = "/logo-zeeway.svg";
  isDocsPage = false;
  private routerSubscription!: Subscription;
  hasDocsPermission = false;
  hasHandleUsersPermission = false;
  isLoggedIn = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private storage: StorageService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.authService.isLoggedIn();

    const company = JSON.parse(
      this.storage.getItem("company") || "{}"
    ) as Company;
    const user = JSON.parse(this.storage.getItem("user") || "{}") as UserInfo;

    if (company && company.configuration?.logoUrl) {
      this.src = company.configuration.logoUrl;
    }

    if (user && user.name) {
      this.userName = user.name;
    }

    if (
      this.router.url.includes("/areas") ||
      this.router.url.includes("/docs")
    ) {
      this.isDocsPage = true;
    }

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.handleUrlChange(event.urlAfterRedirects);
      }
    });

    const userRoles = this.authService.getUserRole();
    this.hasDocsPermission = ["admin", "owner"].some((requiredRole) =>
      userRoles.includes(requiredRole)
    );
    this.hasHandleUsersPermission = ["admin", "owner"].some((requiredRole) =>
      userRoles.includes(requiredRole)
    );
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  handleUrlChange(url: string) {
    if (url.includes("/docs") || url.includes("/areas")) {
      this.isDocsPage = true;
    } else {
      this.isDocsPage = false;
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate(["/login"]);
  }

  navigate() {
    if (this.isDocsPage) {
      this.router.navigate(["/chatbot"]);
      return;
    }
    this.router.navigate(["/areas"]);
  }

  callSupport() {
    window.open(
      `https://api.whatsapp.com/send?phone=${environment.supportPhone}`
    );
  }

  handleUsers() {
    this.router.navigate(["/users"]);
  }
}
